import { render, staticRenderFns } from "./workDetailList.vue?vue&type=template&id=b0eb3518&scoped=true"
import script from "./workDetailList.vue?vue&type=script&lang=js"
export * from "./workDetailList.vue?vue&type=script&lang=js"
import style0 from "./workDetailList.vue?vue&type=style&index=0&id=b0eb3518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0eb3518",
  null
  
)

export default component.exports